import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import PageHeading from "../common/PageHeading";
import $ from "jquery";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { CircularProgress } from "@mui/material";

const Gallery = ({ close }) => {
  const navigate = useNavigate();
  const [isFancyboxOpen, setIsFancyboxOpen] = useState(false);
  const [id, setId] = useState("");
  const [slug, setSlug] = useState("");
  const [images, setImages] = useState([]);
  const galleryRef = useRef(null);
  const [galleryScrollTop, setGalleryScrollTop] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const [visibleImages, setVisibleImages] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation()
  const pathParts = location.pathname.split("/").filter(Boolean);
  const username = pathParts[0];
  localStorage.setItem("open", true)
  useEffect(() => {
    const handlePopState = () => {
      console.log("hii")
      // 1️⃣ If Fancybox is open → CLOSE IT only
      if (window.$ && window.$.fancybox.getInstance()) {
        window.isClosingFancybox = true;
        window.$.fancybox.close();
        setIsFancyboxOpen(false);

        // Push state again so back button doesn't leave page yet
        window.history.pushState({ galleryPage: true }, "");
        return;
      }

      // 2️⃣ Else → navigate back to /username/photos/id
      // navigate(`/${username}/photos/${id}`, { replace: true });
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [username, id, navigate]);


  useEffect(() => {


    const pathSegments = window.location.pathname.split("/");
    const extractedId = pathSegments[3];   // index 2 = id
    const extractedSlug = decodeURIComponent(pathSegments[4]); // index 3 = slug

    setId(extractedId);
    setSlug(extractedSlug);

  }, []);


  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        setIsLoading(true)

        if (id) {
          // id is now the Google Photos album ID taken from the URL
          const albumLink = `https://photos.app.goo.gl/${id}`;

          const res = await apiHandler.post("/event/fetch-album", {
            url: albumLink
          });

          const combinedImages = res || [];
          setImages(combinedImages);
          setVisibleImages(combinedImages.slice(0, 30));
          setIsLoading(false)
        } else {
          setIsLoading(false);
        }
      } catch (err) {
        console.error("Fetch album error:", err);
        setIsLoading(false);
      }
    };

    if (id && !hasFetched) {
      fetchPhoto();
      setHasFetched(true);
    }
  }, [id, hasFetched]);


  useEffect(() => {
    const gallery = galleryRef.current;

    if (gallery) {
      const handleScroll = () => {
        setGalleryScrollTop(gallery.scrollTop);
      };
      gallery.addEventListener("scroll", handleScroll);

      return () => {
        gallery.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  useEffect(() => {
    window.$('[data-fancybox="gallery"]').fancybox({
      buttons: ["slideShow", "thumbs", "zoom", "fullScreen", "share", "close"],
      loop: false,
      autoSize: true,
      protect: true,
      fitToView: true,
      animationEffect: "zoom",
      animationDuration: 400,
      hash: false,
      backFocus: false,
      trapFocus: false,
      beforeShow: function () {
        document.body.style.overflow = "hidden";
        setIsFancyboxOpen(true);

        // Push a state so back button can close it
        if (!window.history.state?.fancyboxOpen) {
          window.history.pushState({ fancyboxOpen: true }, "");
        }
      },

      afterClose: function () {
        document.body.style.overflow = "";
        setIsFancyboxOpen(false);

        // if (window.history.state?.fancyboxOpen) {
        //   window.history.replaceState({}, "", window.location.pathname);
        // }

        const gallery = galleryRef.current;
        if (gallery) {
          requestAnimationFrame(() => {
            gallery.scrollTop = galleryScrollTop;
          });
        }

        if (window.history.state?.fancyboxOpen) {
          window.history.replaceState({}, "", window.location.pathname);
        }

        // if (window.history.state?.fancyboxOpen) {
        //   if (!window.isClosingFancybox) { // <-- only back if not already triggered
        //     window.history.back();
        //   }
        //   window.isClosingFancybox = false; // reset
        // }
      },

      afterShow: function (instance, slide) {
        const img = slide.$content.find("img")[0];
        if (img) {
          if (img.complete) {
            img.classList.add("loaded");
          } else {
            img.onload = () => {
              img.classList.add("loaded");
            };
          }
        }
      },

      onInit: function (instance) {
        console.log("Fancybox initialized");
        instance.$refs.stage.on("click", "a[data-fancybox]", function () {
          console.log("Image clicked");

          const thumbnail = $(this).find("img")[0];
          if (thumbnail) {
            const rect = thumbnail.getBoundingClientRect();

            const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
            const visiblePortion = visibleHeight / rect.height;

            console.log("Visible portion:", visiblePortion);

            if (visiblePortion > 0.05) {
              console.log("okay");
              instance.current.opts.$thumbPosition = {
                left: rect.left,
                top: rect.top,
                width: rect.width,
                height: rect.height,
              };
            } else {
              console.log("no okay");
              instance.current.opts.$thumbPosition = null;
            }
          }
        });
      }
    });



    document.querySelectorAll(".item img").forEach((img) => {
      if (img.naturalHeight) {
        setItemRatio.call(img);
      } else {
        img.addEventListener("load", setItemRatio);
      }
    });

    function setItemRatio() {
      this.parentNode.style.setProperty(
        "--ratio",
        this.naturalHeight / this.naturalWidth
      );
    }
  }, [galleryScrollTop, images]);

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  // const loadMoreImages = () => {
  //   const nextImages = images.slice(visibleImages.length, visibleImages.length + 30);
  //   if (nextImages.length === 0) {
  //     setHasMore(false);
  //     return;
  //   }
  //   setVisibleImages((prev) => [...prev, ...nextImages]);
  // };

  const loadMoreImages = () => {
    if (!hasMore || loading) return;

    const currentVisibleCount = visibleImages.length;
    // ✅ Only proceed if all currently visible images are loaded
    const allLoaded = visibleImages.every((_, index) => loadedImages[index]);
    if (!allLoaded) return;

    setLoading(true);

    setTimeout(() => {
      const nextImages = images.slice(
        currentVisibleCount,
        currentVisibleCount + 30
      );

      if (nextImages.length === 0) {
        setHasMore(false);
      } else {
        setVisibleImages((prev) => [...prev, ...nextImages]);
      }

      setLoading(false);
    }, 500); // Simulated delay
  };



  useEffect(() => {
    const gallery = galleryRef.current;
    if (!gallery || !hasMore) return;

    let scrollTimeout;

    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const { scrollTop, scrollHeight, clientHeight } = gallery;
        if (scrollTop + clientHeight >= scrollHeight - 900) {
          loadMoreImages();
        }
      }, 100); // Debounce scrpoll
    };

    gallery.addEventListener("scroll", handleScroll);
    return () => gallery.removeEventListener("scroll", handleScroll);
  }, [visibleImages, hasMore, loadedImages]);

  return (
    <div
      className="image-gallery"
      style={{ zIndex: "33333333", backgroundColor: "white" }}
    >
      <div className="stickynav Removeinmobile">
        <PageHeading title={slug} backTo={`/${username}/photos/${id}`} />
      </div>

      <div
        ref={galleryRef}
        className="pswp-gallery grid overflow-scroll h-[100vh] scroll-bar"
        id="my-gallery"
      >
        {visibleImages && visibleImages.map((image, index) => (
          <a
            key={index}
            href={`${image}=w1920-h1080`}
            data-fancybox="gallery"
            data-caption={image.caption || `Image ${index + 1}`}
            className="item"
          >
            <img
              src={`${image}=w280-h280`}
              alt={image.caption || `Image ${index + 1}`}
              loading="lazy"
              onLoad={() => handleImageLoad(index)}
              className={`transition-all duration-700 ease-in-out w-full rounded-md ${loadedImages[index]
                ? "blur-0 opacity-100"
                : "blur-sm opacity-30"
                }`}
            />
          </a>
        ))}

      </div>
      {loading && (
        <div className="text-center py-20 text-gray-500 text-sm">
          Loading more images...
        </div>
      )}
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1111111,
            display: "flex",
            gap: "8px",
          }}
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                background: "#333", // dark gray
                animation: `dotBlink 0.8s ${i * 0.2}s infinite alternate`,
              }}
            />
          ))}

          <style>
            {`
        @keyframes dotBlink {
          from { opacity: 0.3; transform: scale(0.7); }
          to   { opacity: 1;   transform: scale(1); }
        }
      `}
          </style>
        </div>
      )}


      {!hasMore && !loading && (
        <div className="text-center py-20 mb-100 text-gray-400 text-sm">
          No more images to show.
        </div>
      )}
    </div>
  );
};

export default Gallery;
